<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-05-12 10:24:14
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-21 11:20:51
 * @FilePath: \YunYin_admin\src\views\Setting\AccountManagement\components\DialogAuth.vue
-->
<template>
  <!-- 查看权限弹窗 -->
  <div class="auth">
    <el-dialog
      class="dialog-bg dialog-auth"
      title="查看权限"
      :visible.sync="dialogAuthVisible"
      :before-close="close"
      width="560px"
    >
      <ul class="list">
        <li class="item">
          <span class="left-side">人员姓名：</span>
          <div class="right-side">{{ curAccount.fullName }}</div>
          <div class="delete-side" v-if="type" @click="showAccount">
            修改角色
          </div>
        </li>
        <li class="item">
          <span class="left-side">登录账号：</span>
          <div class="right-side">{{ curAccount.loginName }}</div>
        </li>
        <li class="item">
          <span class="left-side">手机号：</span>
          <div class="right-side">{{ curAccount.mobile }}</div>
        </li>
        <li class="item">
          <span class="left-side">人员权限：</span>
          <div class="right-side">
            <div
              class="auth-panel"
              v-for="(item, index) in ownAuthData"
              :key="index"
              :class="{ active: curRole == index }"
            >
              <p class="role" @click="handleChangeRole(index)">
                <span
                  ><i class="el-icon-user-solid"></i
                  ><label>{{ item.roleName }}</label></span
                ><i class="el-icon-arrow-down"></i>
              </p>
              <el-tree
                v-show="curRole == index"
                :data="item.authData"
                :props="defaultProps"
              ></el-tree>
            </div>
          </div>
        </li>
      </ul>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogAuth",
  data() {
    return {
      curRole: "",
    };
  },
  props: {
    dialogAuthVisible: {
      type: Boolean,
      default: () => true,
    },
    curAccount: {
      type: Object,
      default: () => {},
    },
    defaultProps: {
      type: Object,
      default: () => {},
    },
    ownAuthData: {
      type: Array,
      default: () => [],
    },
    type: {
      type: Number,
      default: () => 0,
    },
  },
  components: {},
  computed: {},
  methods: {
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-25 09:32:01
     */
    close() {
      this.$emit("close", "dialogAuthVisible");
    },
    showAccount() {
      this.$emit("showAccount");
    },
    handleChangeRole(data) {
      if (this.curRole == data) {
        this.curRole = data == 0 ? -0.1 : -data;
      } else {
        this.curRole = data;
      }
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
::v-deep {
  .dialog-auth {
     .el-dialog__body {
      padding: 20px 30px;
      .list {
        .item {
          display: flex;
          line-height: 35px;
          color: #222222;
          font-size: 16px;
          .right-side {
            flex: 1;
            .auth-panel {
              margin-bottom: 10px;
              &.active {
                background-color: #ffffff;
                border-radius: 3px;
                border: solid 1px #daf3f3;
                .role {
                  color: #018388;
                  background-color: #f1fafa;
                  i {
                    color: #018388;
                  }
                }
              }
              .role {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 40px;
                padding: 0 10px;
                color: #222222;
                background-color: #f8f8f8;
                border-radius: 3px;
                cursor: pointer;
                i {
                  color: #999;
                  font-size: 16px;
                }
                label {
                  margin-left: 5px;
                }
              }
              .el-tree {
                min-height: 100px;
                max-height: 300px;
                overflow-y: auto;
              }
            }
          }
          .delete-side {
            width: 110px;
            height: 36px;
            background: #e9f6f6;
            border-radius: 3px;
            margin-left: 15px;
            font-size: 16px;
            color: #018388;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
          }
          .auth {
            width: 310px;
            max-height: 300px;
            padding-top: 10px;
            margin-top: 5px;
            overflow-y: auto;
            background-color: #ffffff;
            border-radius: 2px;
            border: solid 1px #e5e6eb;
            display: flex;
            box-sizing: border-box;
            &:first-child {
              margin-right: 20px;
            }
          }
          .select-auth {
            margin: 5px 0 0 40px;
          }
        }
      }
      .col-360 {
        width: 300px;
      }
      .con-wrap {
        display: flex;
        .el-form {
          width: 600px;
          margin-right: 10px;
        }
        .auth-panel {
          .con {
            width: 277px;
            border-radius: 2px;
            border: solid 1px #e5e6eb;
            .title {
              position: relative;
              height: 40px;
              padding: 0 16px;
              line-height: 40px;
              background-color: #fbfbfb;
              border-bottom: solid 1px #e5e6eb;
              font-size: 16px;
              color: #222222;
              .left {
                position: absolute;
                top: 13px;
                left: -8px;
                width: 14px;
                height: 14px;
                border-top: 1px solid #e5e6eb;
                border-right: 1px solid #e5e6eb;
                transform: rotate(-135deg);
                background: #fbfbfb;
              }
            }
            .el-tree {
              color: #222222;
              max-height: 300px;
              overflow-y: auto;
              & > .el-tree-node {
                min-height: 40px;
                border-top: solid 1px #e5e6eb;
                &:first-child {
                  border-top: none;
                }
                .el-tree-node__content {
                  height: 40px;
                }
              }
              & > .el-tree-node:last-child {
                border-bottom: none;
              }
            }
          }
        }
      }
    }
  }
  .el-dialog {
    .el-dialog__footer {
      padding-top: 0;
      text-align: center;
    }
  }
  
}
</style>


